import { useEffect, useState } from "react";
import { RiAddLine } from "@remixicon/react";

import Card from "components/Card";
import Button from "components/Button";
import Spinner from "components/Spinner";

import { usePaymentSources } from "v2/pages/billing/hooks/usePaymentSources";

import PaymentSourceCard from "./PaymentSourceCard";
import PaymentSourceForm from "./PaymentSourceForm";


export default function EditPaymentSourcesCard() {
  const { paymentSources, paymentSourcesFetcher, paymentSourcesError, isSettingPrimary } = usePaymentSources();
  const [ showAddNewForm, setShowAddNewForm ] = useState(false);
  const [ submittingNewPaymentSource, setSubmittingNewPaymentSource ] = useState(false);

  useEffect(() => {
    if (paymentSourcesFetcher.state === "submitting") {
      setSubmittingNewPaymentSource(true);
    } else {
      if (submittingNewPaymentSource) {
        setSubmittingNewPaymentSource(false);
        if (!paymentSourcesError) {
          setShowAddNewForm(false);
        }
      }
    }
  }, [ paymentSourcesFetcher, paymentSourcesError, submittingNewPaymentSource ]);

  return (
    <Card
      size="SM"
      borderless
      actionHeader={
        showAddNewForm ? (
          <Card key="add-new-payment-source-form" size="MD">
            <div className="flex flex-col gap-4">
              <Button
                text="Add new payment method"
                className="button button-tertiary w-fit"
                size="SM"
                disabled
              />
              <PaymentSourceForm
                onSuccess={ () => setShowAddNewForm(false) }
                secondaryButton={ () =>
                  <Button
                    text="Cancel"
                    className="button button-secondary"
                    onClick={ () => setShowAddNewForm(false) }
                  />
                }
              />
            </div>
          </Card>
        ) : (
          <Button
            key="add-new-payment-source-button"
            text="Add new payment method"
            className="button button-tertiary w-fit"
            size="SM"
            icon={ {
              Icon: RiAddLine,
              size: "size-4"
            } }
            onClick={ () => setShowAddNewForm(true) }
          />
        )
      }
    >
      <div className="relative flex flex-col gap-2.5">
        { isSettingPrimary && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/60 rounded">
            <Spinner size="MD" />
          </div>
        ) }
        { paymentSources?.map(paymentSource =>
          <PaymentSourceCard
            key={ paymentSource.id }
            paymentSource={ paymentSource }
            mode="edit"
          />
        ) }
      </div>
    </Card>
  );
};
